/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MigratedQuestSample } from './MigratedQuestSample';
import {
    MigratedQuestSampleFromJSON,
    MigratedQuestSampleFromJSONTyped,
    MigratedQuestSampleToJSON,
    MigratedQuestSampleToJSONTyped,
} from './MigratedQuestSample';

/**
 * 
 * @export
 * @interface MigrateOverwolfElectronQuestSourcesResponse
 */
export interface MigrateOverwolfElectronQuestSourcesResponse {
    /**
     * Number of quest configs updated
     * @type {number}
     * @memberof MigrateOverwolfElectronQuestSourcesResponse
     */
    updatedQuestCount: number;
    /**
     * Sample of updated quests for verification
     * @type {Array<MigratedQuestSample>}
     * @memberof MigrateOverwolfElectronQuestSourcesResponse
     */
    sampleQuests: Array<MigratedQuestSample>;
}

/**
 * Check if a given object implements the MigrateOverwolfElectronQuestSourcesResponse interface.
 */
export function instanceOfMigrateOverwolfElectronQuestSourcesResponse(value: object): value is MigrateOverwolfElectronQuestSourcesResponse {
    if (!('updatedQuestCount' in value) || value['updatedQuestCount'] === undefined) return false;
    if (!('sampleQuests' in value) || value['sampleQuests'] === undefined) return false;
    return true;
}

export function MigrateOverwolfElectronQuestSourcesResponseFromJSON(json: any): MigrateOverwolfElectronQuestSourcesResponse {
    return MigrateOverwolfElectronQuestSourcesResponseFromJSONTyped(json, false);
}

export function MigrateOverwolfElectronQuestSourcesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrateOverwolfElectronQuestSourcesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedQuestCount': json['updatedQuestCount'],
        'sampleQuests': ((json['sampleQuests'] as Array<any>).map(MigratedQuestSampleFromJSON)),
    };
}

export function MigrateOverwolfElectronQuestSourcesResponseToJSON(json: any): MigrateOverwolfElectronQuestSourcesResponse {
    return MigrateOverwolfElectronQuestSourcesResponseToJSONTyped(json, false);
}

export function MigrateOverwolfElectronQuestSourcesResponseToJSONTyped(value?: MigrateOverwolfElectronQuestSourcesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatedQuestCount': value['updatedQuestCount'],
        'sampleQuests': ((value['sampleQuests'] as Array<any>).map(MigratedQuestSampleToJSON)),
    };
}

